import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const namespaced = true

const defaultMeta =  {
  current_page: 1,
  desc: false,
  last_page: null,
  order: 'requested',
  per_page: null,
  search: null,
  total: null
}

const _defaultView = 'pending'
const _declinedView = 'declined'
const _archivedView = 'archived'

const state = {
  current: null,
  _defaultView,
  _archivedView,
  _declinedView,
  views: {
    [_defaultView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        archived: false,
        status: 'pending',
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    },
    [_declinedView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        archived: false,
        status: 'declined',
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    },
    [_archivedView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        archived: true,
        status: null,
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    }
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/access-requests/index.js